import {
  AddProductsToPricelistModalTranslation,
  DeletePricelistTranslation,
  EditPricelistTranslation,
  ExportPricelistToExcelModalTranslation,
  ExportPricelistToPdfModalTranslation,
  IncludeNetPriceTranslation,
  ModuleTranslation,
  NetPriceTranslation,
  PricelistDetailsTranslation,
  PricelistFormTranslation,
  PricelistsTranslation,
  ProductAccessoriesTranslation,
  ProductDetailsTranslation,
  ProductImageTranslation,
  ProductPricelistTranslation,
} from './ModuleTranslation';

const pricelistForm: PricelistFormTranslation = {
      name: {
        label: 'Nazwa',
        placeholder: 'Wpisz nazwę',
        maxLengthError: 'Nazwa nie może być dłuższa niż {maxLength} znaków.',
        requiredError: 'Wpisz nazwę.',
      },
      description: {
        label: 'Opis',
        placeholder: 'Wpisz krótki opis',
        maxLengthError: 'Opis nie może być dłuższy niż {maxLength} znaków.',
      },
  errors: {
    createFailed: 'Nie udało się utworzyć cennika. Spróbuj ponownie.',
    updateFailed: 'Nie udało się zapisać cennika. Spróbuj ponownie.',
    nameAlreadyExists: 'Cennik o tej nazwie już istnieje. Użyj innej nazwy.',
  },
};

const addToPricelistModal: AddProductsToPricelistModalTranslation = {
  triggerLabel: 'Dodaj do moich cenników',
  closeLabel: 'Zamknij',
  heading: 'Dodaj do moich cenników',
  itemsToAddFormat: 'Zostanie dodanych {count} pozycji',
  addedToPricelistFormat: 'Dodano {count} pozycji do "{name}"',
  loadingLabel: 'Wczytywanie cenników',
  modeLabel: 'Dodaj wybrane produkty do istniejącego cennika lub do nowego',
  modes: {
    existing: 'Dodaj do istniejącego',
    new: 'Utwórz nowy',
  },
  cancelLabel: 'Anuluj',
  addLabel: 'Dodaj',
  addPendingLabel: 'Dodawanie…',
  createLabel: 'Utwórz',
  createPendingLabel: 'Tworzenie…',
  selectForm: {
    label: 'Wybierz cennik',
    addFailedError: 'Nie udało się dodać produktów do cennika. Spróbuj ponownie.',
  },
  createForm: pricelistForm,
};

const netPrice: NetPriceTranslation = {
  label: 'Cena netto',
  notAvailable: 'b.d.',
};

const productAccessories: ProductAccessoriesTranslation = {
  basePrice: 'Cena bazowa',
  itemNo: 'Nr artykułu',
  name: 'Opis',
  price: 'Cena',
  priceOnDemand: 'na zapytanie',
  netPrice,
};

const productPricelist: ProductPricelistTranslation = {
  basePrice: 'Cena bazowa',
  heading: 'Cennik',
  price: 'Cena',
  priceGroup: 'Grupa cenowa',
  priceOnDemand: 'na zapytanie',
  netPrice,
};

const productImage: ProductImageTranslation = {
  enlargeImageFormat: 'Powiększ zdjęcie {name}',
};

const includeNetPrice: IncludeNetPriceTranslation = {
  label: 'Uwzględnij ceny netto',
  noAgreementsReason: 'Brak dostępnych umów dealerskich.',
};

const exportToExcelModal: ExportPricelistToExcelModalTranslation = {
  closeLabel: 'Zamknij',
  heading: 'Eksport do Excela',
  generatingLabel: 'Poczekaj na utworzenie pliku.',
  readyLabel: 'Twój plik jest gotowy.',
  errorLabel: 'Nie udało się utworzyć pliku. Spróbuj ponownie.',
  exportLabel: 'Eksportuj',
  downloadLabel: 'Pobierz',
  includeNetPrice,
};

const exportToPdfModal: ExportPricelistToPdfModalTranslation = {
  closeLabel: 'Zamknij',
  heading: 'Eksport PDF',
  titleInputLabel: 'Tytuł',
  titleInputPlaceholder: 'Wpisz tytuł',
  titleSubmitLabel: 'Aktualizuj',
  loadingDataLabel: 'Poczekaj na załadowanie produktów.',
  generatingLabel: 'Poczekaj na utworzenie pliku.',
  readyLabel: 'Twój plik jest gotowy.',
  errorLabel: 'Nie udało się utworzyć pliku. Spróbuj ponownie.',
  downloadLabel: 'Pobierz',
  includeNetPrice,
  document: {
    coverPage: {
      heading: 'Cennik',
      createdAtLabel: 'Utworzono',
      itemsLabel: 'Pozycje',
    },
    productSection: {
      itemNoLabel: 'Nr art.',
      detailsHeading: 'Szczegóły produktu',
      pricelist: productPricelist,
      additionalInfoHeading: 'Dodatkowe informacje',
      accessories: {
        heading: 'Akcesoria',
        table: productAccessories,
      },
    },
  },
};

const editPricelist: EditPricelistTranslation = {
  label: 'Edytuj',
  modal: {
    closeLabel: 'Zamknij',
    heading: 'Edytuj cennik',
    cancelLabel: 'Anuluj',
    submitLabel: 'Zapisz',
    submitPendingLabel: 'Zapisywanie…',
    form: pricelistForm,
  },
};

const deletePricelist: DeletePricelistTranslation = {
  label: 'Usuń',
  confirmationFormat: 'Czy na pewno chcesz usunąć "{name}"? Tej operacji nie można cofnąć.',
  successFormat: 'Usunięto "{name}"',
  modal: {
    closeLabel: 'Zamknij',
    heading: 'Usuń cennik',
    cancelLabel: 'Anuluj',
    confirmLabel: 'Usuń',
    confirmPendingLabel: 'Usuwanie…',
    error: 'Nie udało się usunąć cennika. Spróbuj ponownie.',
  },
};

const pricelists: PricelistsTranslation = {
  pageTitleFormat: 'Cenniki',
  pageDescriptionFormat: 'Przeglądaj swoje cenniki',
  tabs: {
    products: 'Produkty',
    pricelists: 'Moje cenniki',
  },
  pricelistListing: {
    searchPlaceholder: 'Szukaj',
    listsFoundLabel: 'Znalezione listy',
    loadingLabel: 'Wczytywanie cenników',
    loadingMoreLabel: 'Wczytywanie kolejnych cenników',
    pricelistList: {
      pricelistListingEmpty: {
        message: 'Nie znaleziono cenników',
        createLabel: 'Utwórz cennik',
      },
      pricelistListingItem: {
        itemsLabel: 'Pozycje:',
        createdAtLabel: 'Utworzono:',
        modifiedAtLabel: 'Ostatnia edycja:',
        actionsLabelFormat: 'Akcje dla {name}',
      },
      itemActions: {
        edit: editPricelist,
        delete: deletePricelist,
      },
    },
    createPricelistModalTriggerLabel: 'Nowy cennik',
    createPricelistModal: {
      closeLabel: 'Zamknij',
      heading: 'Utwórz nowy cennik',
      cancelLabel: 'Anuluj',
      submitLabel: 'Utwórz',
      submitPendingLabel: 'Tworzenie…',
      form: pricelistForm,
    },
  },
  productListing: {
    title: 'Cenniki',
    searchPlaceholder: 'Szukaj',
    expansionToggle: {
      label: 'Rozwiń lub zwiń wszystkie rodziny produktów',
      options: {
        collapseAll: 'Zwiń wszystkie',
        expandAll: 'Rozwiń wszystkie',
      },
    },
    productsFoundLabel: 'Znalezione produkty',
    filters: {
      heading: 'Filtry',
      brands: {
        label: 'Marka',
      },
      types: {
        label: 'Typ',
      },
      sectors: {
        label: 'Obszar',
      },
      priceRange: {
        label: 'Cena',
        range: {
          from: 'Od',
          to: 'Do',
        },
      },
    },
    table: {
      title: 'Produkty',
      emptyText: 'Nie znaleziono produktów',
      loadingLabel: 'Wczytywanie produktów',
      loadingMoreLabel: 'Wczytywanie kolejnych produktów',
      selectAll: 'Zaznacz wszystkie produkty',
      selectProduct: 'Zaznacz',
      expandFamily: 'Pokaż produkty',
      collapseFamily: 'Ukryj produkty',
      expandColumnLabel: 'Rozwiń',
      itemNo: 'Nr art.',
      image: 'Zdjęcie',
      productImage,
      brand: 'Marka',
      model: 'Model',
      price: 'Cena',
      priceInfo: {
        label: 'Informacje o cenach',
        content: 'Ceny wyjściowe. Ceny różnią się w zależności od wybranych tkanin i opcji.',
      },
      fromLabel: 'od',
      productsCountLabel: 'produkty',
      newBadge: 'NOWOŚĆ',
      modelActionLabel: 'Ceny',
      familyActionLabel: 'Informacje',
      actionLabel: 'Akcja',
    },
    selectionPanel: {
      selectedCountFormat: 'Wybrano {count} pozycji',
      export: 'Eksportuj',
      clearSelection: 'Wyczyść zaznaczenie',
    },
    addToPricelistModal,
    exportToPdfModal,
    details: {
      closeLabel: 'Zamknij',
      loadingLabel: 'Wczytywanie szczegółów rodziny',
      specificationHeading: 'Specyfikacja',
    },
    modelDetails: {
      closeLabel: 'Zamknij',
      loadingLabel: 'Wczytywanie cen',
      pricelist: {
        caption: 'Cennik',
        productGroup: 'GP',
        basePrice: 'Cena bazowa',
        price: 'Cena',
        priceOnDemand: 'na zapytanie',
        agreementDiscount: 'Rabat z umowy dealera',
        netPrice,
      },
      detailsLinkLabel: 'Przejdź do strony produktu, aby zobaczyć szczegółowe ceny',
    },
  },
};

const productDetails: ProductDetailsTranslation = {
  pageTitleFormat: '',
  pageDescriptionFormat: 'Ceny i akcesoria dla {name}',
  backlinkLabel: 'Wróć',
  downloadLabel: 'Pobierz',
  lastUpdatedLabel: 'Ostatnia aktualizacja:',
  itemNoLabel: 'Nr art.',
  addToPricelistModal,
  exportToPdfModal,
  familyDetails: {
    triggerLabel: 'Szczegóły rodziny',
    closeLabel: 'Zamknij',
    descriptionHeading: 'Opis',
    featuresHeading: 'Funkcje',
  },
  terms: {
    triggerLabel: 'Warunki',
    closeLabel: 'Zamknij',
    heading: 'Ogólne warunki sprzedaży i dostawy',
    introFormat: 'Ten dokument dotyczy autoryzowanych dystrybutorów {brand}.',
    loadingLabel: 'Wczytywanie warunków',
  },
  closeLabel: 'Zamknij',
  productDetailsHeading: 'Szczegóły produktu',
  accessoriesHeading: 'Akcesoria',
  additionalInfoHeading: 'Dodatkowe informacje',
  pricelist: productPricelist,
  accessories: productAccessories,
};

const pricelistDetails: PricelistDetailsTranslation = {
  pageTitleFormat: '',
  pageDescriptionFormat: 'Ceny produktów z cennika {name}',
  backlinkLabel: 'Wróć',
  exportLabel: 'Excel',
  downloadLabel: 'PDF/Drukuj',
  settingsLabel: 'Ustawienia',
  itemsLabel: 'Pozycje:',
  createdAtLabel: 'Utworzono:',
  modifiedAtLabel: 'Ostatnia edycja:',
  regionLabel: 'Region',
  currencyLabel: 'Waluta',
  pricesRefreshedAtLabel: 'Ceny odświeżone',
  currencyExcludingVatFormat: '{currency} (bez VAT)',
  searchPlaceholder: 'Szukaj',
  productsLabel: 'Produkty w tym cenniku',
  itemsFoundLabel: 'Pozycje',
  emptyText: 'Nie znaleziono pozycji',
  loadingLabel: 'Wczytywanie pozycji',
  loadingMoreLabel: 'Wczytywanie kolejnych pozycji',
  exportToExcelModal,
  exportToPdfModal,
  product: {
    actionsLabelFormat: 'Akcje dla {name}',
    pricelist: productPricelist,
    productImage,
    additionalInfoHeading: 'Dodatkowe informacje',
    accessories: {
      heading: 'Akcesoria',
      loadingLabel: 'Wczytywanie akcesoriów',
      table: productAccessories,
    },
  },
  pricelistActions: {
    edit: editPricelist,
    delete: deletePricelist,
  },
  productActions: {
    remove: {
      label: 'Usuń',
      confirmationFormat: 'Czy na pewno chcesz usunąć "{name}" z tego cennika?',
      successFormat: 'Usunięto "{name}"',
      modal: {
        closeLabel: 'Zamknij',
        heading: 'Usuń produkt',
        cancelLabel: 'Anuluj',
        confirmLabel: 'Usuń',
        confirmPendingLabel: 'Usuwanie…',
        error: 'Nie udało się usunąć produktu. Spróbuj ponownie.',
      },
    },
  },
};

const translation: ModuleTranslation = {
  pricelistDetails,
  pricelists,
  productDetails,
};

export default translation;
